import { render, staticRenderFns } from "./article-section.vue?vue&type=template&id=a0d0a68a"
import script from "./article-section.vue?vue&type=script&lang=js"
export * from "./article-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports